import kalamata from "@/assets/collections/Kalamata.png";
import amfissis from "@/assets/collections/Amfissis.png";
import uslu from "@/assets/collections/Uslu.png";
import halkidiki from "@/assets/collections/Halkidiki.png";
import gemlik from "@/assets/collections/Gemlik.png";
import grilGreen from "@/assets/collections/Gril-Green.png";
import regina_oil from "@/assets/collections/Regina_oil.jpg";
import extra_virgin from "@/assets/collections/Extra_Virgin.png";
import blend_oil from "@/assets/collections/Blend_Oil.png";
import confit from "@/assets/collections/Confit.png";
import olivePaste from "@/assets/collections/Olive_Paste.png";
import kalamata_pitted from "@/assets/collections/Kalamata/pitted_kalamata.png";
import kalamata_paste from "@/assets/collections/Kalamata/paste_kalamata.png";
import kalamata_blonde from "@/assets/collections/Kalamata/blonde_kalamata.png";
import kalamata_raisin from "@/assets/collections/Kalamata/raisin_kalamata.png";
import halkidiki_whole from "@/assets/collections/Halkidiki/whole_halkidiki.png";
import halkidiki_sliced from "@/assets/collections/Halkidiki/sliced_halkidiki.png";
import halkidiki_stuffed_almond from "@/assets/collections/Halkidiki/stuffed_almond_halkidiki.png";
import halkidiki_stuffed_pepper from "@/assets/collections/Halkidiki/stuffed_pepper_halkidiki.png";
import halkidiki_marinated_herbs from "@/assets/collections/Halkidiki/marinated_herbs_halkidiki.png";
import halkidiki_spicy from "@/assets/collections/Halkidiki/spicy_halkidiki.png";
import confit_pitted from "@/assets/collections/Confit/pitted_confit.png";
import confit_sliced from "@/assets/collections/Confit/sliced_confit.png";
import amfissa_pitted from "@/assets/collections/Amfissa/pitted_amfissa.png";
import amfissa_blonde from "@/assets/collections/Amfissa/blonde_amfissa.png";
import amfissa_raisin from "@/assets/collections/Amfissa/raisin_amfissa.png";
import gemlik_pitted from "@/assets/collections/Gemlik/pitted_gemlik.png";
import uslu_natural_pitted from "@/assets/collections/Uslu/natural_pitted_uslu.png";



export type OliveImage = {
  src: string;
  alt: string;
  width: number;
  height: number;
};

export type LocalizedText = {
  bg: string;
  en: string;
};

export type OliveOffer = 'olives' | 'oliveOil';

export type OliveType = {
  id: string;
  name: LocalizedText;
  description: LocalizedText;
  country: 'greek' | 'turkish';
  subtypes?: LocalizedText[];
  varieties?: LocalizedText[];
  packaging?: LocalizedText[];
  images: OliveImage[];
};

export type OliveBrand = {
  id: string;
  name: LocalizedText;
  description: LocalizedText;
  offers: OliveOffer[];
  packaging?: LocalizedText[];
  images: OliveImage[];
};

export const oliveOfferLabels: Record<OliveOffer, LocalizedText> = {
  olives: { bg: 'маслини', en: 'olives' },
  oliveOil: { bg: 'маслиново масло', en: 'olive oil' },
};

export const oliveTypes: OliveType[] = [
  {
    id: 'kalamata',
    name: { bg: 'Каламата', en: 'Kalamata' },
    description: {
      bg: 'Маслините Каламата обикновено се събират от края на ноември до януари, в зависимост от климата и региона. Плодовете се събират, когато станат тъмнокафяви до черни, но все още са твърди, за да се запази качеството им.',
      en: 'Kalamata olives are typically harvested from late November to January, depending on the climate and region. The fruits are collected when they turn dark brown to black but remain firm to preserve their quality.',
    },
    country: 'greek',
    varieties: [
      { bg: 'с костилка', en: 'whole' },
      { bg: 'без костилка', en: 'pitted' },
      { bg: 'паста', en: 'paste' },
      { bg: 'блонд', en: 'blonde' },
      { bg: 'стафидирани', en: 'raisin' },
    ],
    packaging: [
      { bg: 'тенекии', en: 'tins' },
      { bg: 'кофи (PP)', en: 'buckets (PP)' },
      { bg: 'пластмасови бидончета', en: 'plastic barrels' },
      { bg: 'вакуум', en: 'vacuum packs' },
    ],
    images: [
      {
        src: kalamata,
        alt: 'Kalamata olives',
        width: 1024,
        height: 1024,
      },
      {
        src: kalamata_pitted,
        alt: 'Kalamata pitted olives in bowl',
        width: 750,
        height: 410,
      },
      {
        src: kalamata_paste,
        alt: 'Kalamata olive paste in bowl',
        width: 750,
        height: 410,
      },
      {
        src: kalamata_blonde,
        alt: 'Kalamata blonde olives in bowl',
        width: 750,
        height: 410,
      },
      {
        src: kalamata_raisin,
        alt: 'Kalamata raisin olives in bowl',
        width: 750,
        height: 410,
      },
    ],
  },
  {
    id: 'halkidiki',
    name: { bg: 'Халкидики', en: 'Halkidiki' },
    description: {
      bg: 'Маслините Халкидики се берат от септември до около средата на октомври. След третиране в разреден разтвор, придобиват характерен зелено-златист цвят.',
      en: 'Halkidiki olives are harvested from September to mid-October. After treatment in a dilute solution, they acquire a characteristic golden-green color.',
    },
    country: 'greek',
    varieties: [
      { bg: 'без костилка', en: 'pitted' },
      { bg: 'с костилка', en: 'whole' },
      { bg: 'нарязани', en: 'sliced' },
      { bg: 'пълнени с бадем', en: 'stuffed with almond' },
      { bg: 'пълнени с червена чушка', en: 'stuffed with red pepper' },
      { bg: 'мариновани с подправки', en: 'marinated with herbs' },
      { bg: 'пикантни', en: 'spicy' },
    ],
    packaging: [
      { bg: 'тенекии', en: 'tins' },
      { bg: 'буркани', en: 'jars' },
      { bg: 'вакуум', en: 'vacuum packs' },
    ],
    images: [
      {
        src: halkidiki,
        alt: 'Halkidiki olives',
        width: 1024,
        height: 1024,
      },
      {
        src: halkidiki_whole,
        alt: 'Halkidiki whole olives in bowl',
        width: 750,
        height: 410,
      },
      {
        src: halkidiki_sliced,
        alt: 'Halkidiki sliced olives in bowl',
        width: 750,
        height: 410,
      },
      {
        src: halkidiki_stuffed_almond,
        alt: 'Halkidiki stuffed with almond olives in bowl',
        width: 750,
        height: 410,
      },
      {
        src: halkidiki_stuffed_pepper,
        alt: 'Halkidiki stuffed with red pepper olives in bowl',
        width: 750,
        height: 410,
      },
      {
        src: halkidiki_marinated_herbs,
        alt: 'Halkidiki marinated with herbs olives in bowl',
        width: 750,
        height: 410,
      },
      {
        src: halkidiki_spicy,
        alt: 'Halkidiki spicy olives in bowl',
        width: 750,
        height: 410,
      },
    ],
  },
  {
    id: 'confit',
    name: { bg: 'Конфит', en: 'Confit' },
    description: {
      bg: 'Черните маслини Конфит се берат зелени, а черният цвят се придобива чрез процес, наречен оксидация.',
      en: 'Black Confit olives are harvested green, and their black color is achieved through a process called oxidation.',
    },
    country: 'greek',
    varieties: [
      { bg: 'с костилка', en: 'whole' },
      { bg: 'без костилка', en: 'pitted' },
      { bg: 'нарязани', en: 'sliced' },
    ],
    packaging: [
      { bg: 'консерви', en: 'cans' },
      { bg: 'буркани', en: 'jars' },
    ],
    images: [
      {
        src: confit,
        alt: 'Confit olives',
        width: 1024,
        height: 1024,
      },
      {
        src: confit_pitted,
        alt: 'Confit pitted olives in bowl',
        width: 750,
        height: 410,
      },
      {
        src: confit_sliced,
        alt: 'Confit sliced olives in bowl',
        width: 750,
        height: 410,
      },
    ],
  },
  {
    id: 'amfissa',
    name: { bg: 'Амфиса', en: 'Amfissa' },
    description: {
      bg: 'Маслините Амфиса обикновено се събират от края на октомври до началото на февруари според географските ширини, в които се намират плантациите.',
      en: 'Amfissa olives are typically harvested from late October to early February, depending on the latitude of the groves.',
    },
    country: 'greek',
    varieties: [
      { bg: 'с костилка', en: 'whole' },
      { bg: 'без костилка', en: 'pitted' },
      { bg: 'блонд', en: 'blonde' },
      { bg: 'стафидирани', en: 'raisin' },
    ],
    packaging: [
      { bg: 'тенекии', en: 'tins' },
      { bg: 'кофи (PP)', en: 'buckets (PP)' },
    ],
    images: [
      {
        src: amfissis,
        alt: 'Amfissa olives',
        width: 1024,
        height: 1024,
      },
      {
        src: amfissa_pitted,
        alt: 'Amfissa pitted olives in bowl',
        width: 750,
        height: 410,
      },
      {
        src: amfissa_blonde,
        alt: 'Amfissa blonde olives in bowl',
        width: 750,
        height: 410,
      },
      {
        src: amfissa_raisin,
        alt: 'Amfissa raisin olives in bowl',
        width: 750,
        height: 410,
      },
    ],
  },
  {
    id: 'gemlik',
    name: { bg: 'Гемлик', en: 'Gemlik' },
    description: {
      bg: 'Маслините Гемлик се берат обикновено от ноември до януари, в зависимост от климата и степента на узряване. Този сорт е ценен заради високото съдържание на масло и богатия им вкус.',
      en: 'Gemlik olives are typically harvested from November to January, depending on climate and ripeness. This variety is prized for its high oil content and rich flavor.',
    },
    country: 'turkish',
    varieties: [
      { bg: 'с костилка', en: 'whole' },
      { bg: 'без костилка', en: 'pitted' },
    ],
    packaging: [
      { bg: 'кофи (PP)', en: 'buckets (PP)' },
      { bg: 'буркани (PP)', en: 'jars (PP)' },
    ],
    images: [
      {
        src: gemlik,
        alt: 'Gemlik olives',
        width: 1024,
        height: 1024,
      },
      {
        src: gemlik_pitted,
        alt: 'Gemlik pitted olives in bowl',
        width: 750,
        height: 410,
      },
    ],
  },
  {
    id: 'uslu',
    name: { bg: 'Услу', en: 'Uslu' },
    description: {
      bg: 'Маслините Услу се берат от края на октомври до декември, според предназначението им. За зелени маслини брането започва в края на октомври, а за черни - през декември, когато плодът потъмнее и узрее напълно.',
      en: 'Uslu olives are harvested from late October to December, depending on their intended use. Harvesting for green olives begins in late October, while for black olives it starts in December when the fruit darkens and fully ripens.',
    },
    country: 'turkish',
    subtypes: [
      { bg: 'натурални', en: 'natural' },
      { bg: 'черни', en: 'black' },
    ],
    varieties: [
      { bg: 'с костилка', en: 'whole' },
      { bg: 'без костилка', en: 'pitted' },
    ],
    packaging: [
      { bg: 'кофи (PP)', en: 'buckets (PP)' },
      { bg: 'буркани (PP)', en: 'jars (PP)' },
      { bg: 'вакуум', en: 'vacuum packs' },
    ],
    images: [
      {
        src: uslu,
        alt: 'Uslu olives',
        width: 1024,
        height: 1024,
      },
      {
        src: uslu_natural_pitted,
        alt: 'Uslu natural pitted olives in bowl',
        width: 750,
        height: 410,
      },
    ],
  },
  {
    id: 'gril-green',
    name: { bg: 'Гриловани зелени маслини', en: 'Grilled Green' },
    description: {
      bg: 'Идеалният избор за любителите на автентичния вкус и уникалните аромати. Процесът на мариноване и гриловане подчертава богатството на маслиновия вкус, като същевременно запазва свежестта и сочността на маслините.',
      en: 'The perfect choice for lovers of authentic taste and unique aromas. The marination and grilling process highlights the richness of the olive flavor while preserving the freshness and texture of the olives.',
    },
    country: 'turkish',
    varieties: [
      { bg: 'без костилка', en: 'pitted' },
    ],
    packaging: [
      { bg: 'буркани (PP)', en: 'jars (PP)' },
      { bg: 'вакуум', en: 'vacuum packs' },
    ],
    images: [
      {
        src: grilGreen,
        alt: 'Grilled Green olives',
        width: 1024,
        height: 1024,
      },
    ],
  },
  {
    id: 'olive-paste',
    name: { bg: 'Маслинова паста', en: 'Olive Paste' },
    description: {
      bg: 'Нежна паста от селектирани маслини, идеална за брускети, сандвичи и кулинарни експерименти.',
      en: 'Smooth paste made from selected olives, perfect for bruschettas, sandwiches, and culinary experiments.',
    },
    country: 'greek',
    varieties: [
      { bg: 'класическа', en: 'classic' },
    ],
    packaging: [
      { bg: 'буркан 0.200 кг', en: 'jar 0.200 kg' },
      { bg: 'буркан 0.400 кг', en: 'jar 0.400 kg' },
      { bg: '2.5 кг', en: '2.5 kg' },
      { bg: '4 кг', en: '4 kg' },
    ],
    images: [
      {
        src: olivePaste,
        alt: 'Olive paste',
        width: 1024,
        height: 1024,
      },
    ],
  },
];

export const oliveBrands: OliveBrand[] = [
  {
    id: 'extra-virgin',
    name: { bg: 'Екстра Върджин', en: 'Extra Virgin' },
    description: {
      bg: 'Най-висок клас маслиново масло, добито изцяло чрез механично пресяване. Отличава се с богат аромат, златист цвят и безупречно качество за ценители.',
      en: 'Premium grade olive oil extracted purely through mechanical pressing. Distinguished by its rich aroma, golden hue, and impeccable quality for connoisseurs.',
    },
    offers: ['oliveOil'],
    packaging: [
      { bg: 'стъклени бутилки', en: 'glass bottles' },
      { bg: 'метална кутия', en: 'metal tin' },
    ],
    images: [
      {
        src: extra_virgin,
        alt: 'Extra Virgin olive oil',
        width: 1200,
        height: 800,
      },
    ],
  },
  {
    id: 'olive-oil-blend',
    name: { bg: 'Смес от масла', en: 'Olive Oil Blend' },
    description: {
      bg: 'Балансиран микс от рафинирани масла и Екстра Върджин, идеален за готвене при висока температура. Комбинира издръжливост с деликатен маслинов вкус.',
      en: 'A balanced mix of refined oils and Extra Virgin, ideal for high-heat cooking. Combines durability with a delicate olive taste.',
    },
    offers: ['oliveOil'],
    packaging: [
      { bg: 'бутилки (PP)', en: 'bottles (PP)' },
    ],
    images: [
      {
        src: blend_oil,
        alt: 'Helios olive oil',
        width: 1200,
        height: 800,
      },
    ],
  },
];

export const oliveData = {
  types: oliveTypes,
  brands: oliveBrands,
};
